import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  OutlinedInput,
  Switch,
  TextField,
} from "@mui/material";
import { red, green } from "@mui/material/colors";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import db, { auth } from "../firebase";
import { blue } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import CottageIcon from "@mui/icons-material/Cottage";

function SellForm() {
  const [rows, setRows] = useState([]);
  const [bulkDataId, setBulkDataId] = useState([]);
  const [bulkDataName, setBulkDataName] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      const colRef = collection(db, "products");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setRows(docs);
    })();
  }, []);
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  var subjects = [
    {
      value: "Income",
      label: "Income",
    },
    {
      value: "Expense",
      label: "Expense",
    },
    // {
    //   value: "Trainee",
    //   label: "Trainee",
    // },
  ];
  var categories = [
    {
      value: "Accessories",
      label: "Accessories",
    },
    {
      value: "Stationary",
      label: "Stationary",
    },
    {
      value: "Soft Toys",
      label: "Soft Toys",
    },
    {
      value: "Imported Toys",
      label: "Imported Toys",
    },
    // {
    //   value: "Trainee",
    //   label: "Trainee",
    // },
  ];
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const date = new Date();
      const time = date.toLocaleTimeString();
      setCurrentTime(time);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const [isUpdated, setUpdated] = useState({ state: false, color: "", message: "" });
  const COLORS = {
    red: "error",
    green: "success",
  };

  const SubmitButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    color: "white",
    "&:hover": {
      backgroundColor: green[700],
    },
  }));

  const [user, setUser] = useState(null);
  const [uid, setUid] = useState(null);
  const [userData, setUserData] = useState([]);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        setUid(user.uid);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      const q = query(collection(db, "users"), where("uid", "==", uid));
      const snapshots = await getDocs(q);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setUserData(docs);
    };

    if (uid) {
      fetchUserData();
    }
  }, [uid]);

  // Access the "user" field once the data is retrieved
  useEffect(() => {
    if (userData && userData.length > 0) {
      const { userName } = userData[0];
      setUserName(userName);
    }
  }, [userData]);

  const getCurrentMonth = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // "+1" because getMonth() returns 0-indexed month (0 for January)
    return currentMonth;
  };

  const getCurrentYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear;
  };
  
  useEffect(() => {
    (async () => {
      const colRef = collection(db, "products");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      const ids = docs.map((row) => {
        return row.productId;
      });
      const names = docs.map((row) => {
        return row.productName;
      });
      setBulkDataId(ids);
      setBulkDataName(names);
    })();
  }, []);

  const [docRef, setDocRef] = useState();
  var id = rows.length + 1;
  var date = currentDate;
  var time = currentTime;
  var createdOn = currentTime;
  var createdBy = userName;
  var month = getCurrentMonth();
  var year = getCurrentYear();
  var status = "SOLD";
  const [subject, setSubject] = useState("");
  const [amount, setAmount] = useState("");
  const [cost, setCost] = useState("");
  const [price, setPrice] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [description, setDescription] = useState("");
  const [productId, setProductId] = useState(bulkDataId[0] || '');
  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [category, setCategory] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [remarks, setRemarks] = useState("");
  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };
  const handleQuantityChange = (e) => {
    const newQuantity = e.target.value;
    setQuantity(newQuantity);
    updateTotalAmount(newQuantity, amount);
  };

  const handleAmountChange = (e) => {
    const newAmount = e.target.value;
    setAmount(newAmount);
    updateTotalAmount(quantity, newAmount);
  };

  const updateTotalAmount = (newQuantity, newAmount) => {
    const calculatedTotalAmount =
      parseFloat(newQuantity) * parseFloat(newAmount);
    setTotalAmount(isNaN(calculatedTotalAmount) ? "" : calculatedTotalAmount);
  };

  const clearFields = () => {
    setSubject("");
    setAmount("");
    setDescription("");
  };

  const uniqueItems = [...new Set(rows.map((i) => i.productId))];
  const uniqueItem = uniqueItems.length === 1 ? uniqueItems[0] : uniqueItems;
  const uniqueId = Array.isArray(uniqueItem)
    ? uniqueItem.map((value) => <span key={value}>{value}, </span>)
    : uniqueItem;

  const handleProductIdChange = (e, newValue) => {
    setProductId(newValue);
    (async () => {
      const colRef = collection(db, "products");
      const itemRef = query(colRef, where("productId", "==", newValue));
      const snapshots = await getDocs(itemRef);
      const docItemRef = doc(db, "products", snapshots.docs[0].id);
      const docs = snapshots.docs[0].data();
      console.log(docs.description);
      if (docs.productId === newValue) {
        setProductName(docs.productName);
        setCategory(docs.category);
        setSubject(docs.subject);
        setAmount(docs.amount);
        setPrice(docs.price);
        setRemarks(docs.remarks);
        setDescription(docs.description);
        setQuantity(docs.quantity);
        setTotalAmount(docs.totalAmount);
      }
      // setDocRef(docItemRef);
    })();
  };

  const handleSubmit = async (e) => {
    const isIdInBulkData = bulkDataId.includes(productId);
    e.preventDefault();
    if (isIdInBulkData === true) {
      e.preventDefault();
      const colRef = collection(db, "products");
      const itemRef = query(colRef, where("productId", "==", productId));
      const snapshots = await getDocs(itemRef);
      const docs = snapshots.docs[0].data()

      if (!snapshots.empty) {
        const firstDoc = snapshots.docs[0];
        const docItemRef = doc(db, "products", firstDoc.id);
        const docItemRef1 = doc(db, "transactions", firstDoc.id);
        const docData = firstDoc.data();


        const updatedQuantity =
          parseInt(docData.quantity, 10) - quantity;
        const updatedTotalAmount =
          parseInt(docData.totalAmount, 10) - totalAmount;
          console.log(updatedTotalAmount)

        try {
          await setDoc(docItemRef, {
            id: docs.id,
            date: date,
            time: time,
            month: month,
            year: year,
            createdOn: docs.createdOn,
            createdBy: docs.createdBy,
            modifiedOn: time,
            modifiedBy: userName,
            productId: productId,
            productName: productName,
            category: category,
            // remarks: remarks,
            // description: description,
            subject: "EXPENSE",
            quantity: updatedQuantity,
            amount: amount,
            price: price,
            totalAmount: updatedTotalAmount,
            status: status
          })
          await setDoc(docItemRef1, {
            id: docs.id,
            date: date,
            time: time,
            month: month,
            year: year,
            createdOn: docs.createdOn,
            createdBy: docs.createdBy,
            modifiedOn: time,
            modifiedBy: userName,
            productId: productId,
            productName: productName,
            category: category,
            // remarks: remarks,
            // description: description,
            subject: "EXPENSE",
            quantity: quantity,
            amount: amount,
            price: price,
            totalAmount: totalAmount,
            status: status
          });
          setUpdated({ state: true, color: COLORS.green, message: "Updated Successfully" });
          setTimeout(() => {
            setUpdated({ state: false, color: COLORS.green, message: "Updated Successfully" });
          }, 8000);
          // alert("Updated Successfully");
          // navigate("/history");
        } catch (err) {
          // console.log(err)
          setUpdated({ state: true, color: COLORS.red, message: "Failed" });
          setTimeout(() => {
            setUpdated({ state: false, color: COLORS.red, message: "Failed" });
          }, 8000);
        }
      }
    } else {
      if (subject && amount && date && quantity && user !== "") {
        await addDoc(collection(db, "products"), {
          id,
          productId,
          productName,
          category,
          date,
          time,
          month,
          year,
          subject: "EXPENSE",
          // remarks,
          // description,
          quantity,
          amount,
          price,
          totalAmount,
          createdOn,
          createdBy,
          status
        })
        await addDoc(collection(db, "transactions"), {
          id,
          productId,
          productName,
          category,
          date,
          time,
          month,
          year,
          subject: "EXPENSE",
          // remarks,
          // description,
          quantity,
          amount,
          price,
          totalAmount,
          createdOn,
          createdBy,
          status
        })
          .then((res) => {
            setUpdated({ state: true, color: COLORS.green, message: "Updated Successfully" });
            setTimeout(() => {
              setUpdated({ state: false, color: COLORS.green, message: "Updated Successfully" });
            }, 3000);
            // alert("Added Successfully");
          })
          .catch((err) => {
            setUpdated({ state: true, color: COLORS.red, message: "Failed to Update"  });
            setTimeout(() => {
              setUpdated({ state: false, color: COLORS.red, message: "Failed to Update" });
            }, 3000);
          });
        // navigate("/history");
      } else {
        setUpdated({ state: true, color: COLORS.red, message: "Please!.. Fill Mandatory"  });
            setTimeout(() => {
              setUpdated({ state: false, color: COLORS.red, message: "Please!.. Fill Mandatory" });
            }, 3000);
        // alert("Please!.. Fill Mandatory");
      }
    }
    handleClear();
  };

  const handleCancel = () => {
    clearFields();
    window.location.reload();
  };

  const AddButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: "#1f1966",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#1f1979",
    },
  }));

  const handleNav = () => {
    navigate("/index");
  };

  const handleClear = () => {
    setSubject("INCOME");
    setAmount("");
    setCost("");
    setPrice("");
    setTotalAmount("");
    setDescription("");
    setProductId("");
    setProductName("");
    setQuantity("");
    setCategory("");
    setRemarks("");
    setSelectedSubject("");
  };


  return (
    <>
    {isUpdated.state && (
      <Alert
        severity={isUpdated.color}
        style={{
          position: "fixed",
          marginTop: "80px",
          marginLeft:"10px",
          zIndex: "1000",
        }}
      >
        &ensp;{isUpdated.message}
      </Alert>
    )}
    <div className="form-container">
      {/* <Button
        startIcon={<CottageIcon />}
        onClick={handleNav}
        variant="contained"
        sx={{ position: "relative", top: "10px", width: "400px" }}
      >
        Home
      </Button> */}
      <div className="inputs">
        <label htmlFor="product-input">
          Product Id <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <Autocomplete
          id="product-input"
          options={bulkDataId}
          value={productId}
          onChange={handleProductIdChange}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Please enter text"
              variant="outlined"
              sx={{ width: "37ch", padding: "0px" }}
            />
          )}
        />
      </div>
      <div className="inputs">
        <label htmlFor="input">
          Product Name <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        {/* <Autocomplete
          id="product-input"
          options={bulkDataName}
          value={productName}
          onChange={(event, newValue) => setProductName(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Please enter text"
              variant="outlined"
              sx={{ width: "37ch", padding: "0px" }}
            />
          )}
          
        /> */}
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Please enter Name"
          value={productName}
          onChange={(e) => {
            setProductName(e.target.value)
          }} 
          disabled
        />
      </div>
      <div className="inputs-cat">
        <label htmlFor="input">
          Category <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <TextField
          id="outlined-select-currency"
          select
          sx={{ width: "37ch", padding: "0px" }}
          className="dropdown"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          disabled
        >
          {categories.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
      {/* <div className="inputs">
        <label htmlFor="input">
          Subject <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <TextField
          id="outlined-select-currency"
          select
          sx={{ width: "37ch", padding: "0px" }}
          className="dropdown"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        >
          {subjects.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div> */}
      {/* <div className="inputs">
        <label htmlFor="amount">
          Cost <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Please enter cost"
          value={cost}
          onChange={(e) => {
            setCost(e.target.value)
          }} 
        />
      </div> */}
      <div className="inputs">
        <label htmlFor="amount">
          Price <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Please enter price"
          value={price}
          onChange={(e) => {
            setPrice(e.target.value)
          }} 
          disabled
        />
      </div>
      <div className="inputs">
        <label htmlFor="amount">
          Cost <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Please enter amount"
          value={amount}
          onChange={handleAmountChange}
          disabled
        />
      </div>
      <div className="inputs">
        <label htmlFor="quantity">
          Quantity <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Please enter quantity"
          value={quantity}
          onChange={handleQuantityChange}
        />
      </div>
      <div className="inputs">
        <label htmlFor="totalAmount">
          Total Amount <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Total amount will be calculated"
          value={totalAmount}
          readOnly
          disabled
        />
      </div>
      {/* Commented out for now since the variables are not provided */}
      {/* <div className="inputs">
        <label htmlFor="input">
          Name <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <OutlinedInput
          sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
          placeholder="Please enter text"
          defaultValue={userName}
        />
      </div> */}
        {/* <div className="inputs">
          <label htmlFor="input">Remarks</label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter Remarks"
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
          />
        </div>
      <div className="inputs">
        <label htmlFor="input">
          Description <span style={{ color: "red" }}>*</span>
        </label>
        <br />
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={4}
          sx={{ width: "37ch" }}
          placeholder="Please enter text"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
        />
      </div> */}
    </div>
      <div className="buttons">
        <Button variant="outlined" color="error" onClick={handleClear}>
          Cancel
        </Button>
        <Button variant="contained" className="submit" onClick={handleSubmit}>
          Update
        </Button>
      </div>
    </>
  );
}

export default SellForm;
